import React from "react";
import "../App.css";

function Header() {
  return (
    <div className="header">
      <div className="header-logo">E-Voter</div>
    </div>
  );
}

export default Header;
